import React, { useState } from "react";
import "./MenuImage.css";
const WIDTHS = [320, 640, 960, 1280];
export function imageUrl(baseUrl, width) {
  return typeof baseUrl === "string" &&
    /^https:\/\/imagedelivery\.net\/[\w-]+\/[\w-]+$/.test(baseUrl)
    ? `${baseUrl}/w=${width},fit=scale-down`
    : null;
}
const position = (value) =>
  Number.isFinite(value) ? Math.max(0, Math.min(100, value)) : 50;
export default function MenuImage({
  image,
  alt,
  sizes = "(max-width: 640px) 100vw, (max-width: 1000px) 50vw, 33vw",
  priority = false,
  fallback = null,
}) {
  const [failedUrl, setFailedUrl] = useState(null);
  const src = imageUrl(image?.baseUrl, 640);
  if (!src || failedUrl === src) return fallback;
  return (
    <div className="menu-image">
      <img
        src={src}
        srcSet={WIDTHS.map(
          (width) => `${imageUrl(image.baseUrl, width)} ${width}w`,
        ).join(", ")}
        sizes={sizes}
        alt={image.alt || alt || ""}
        width="1280"
        height="960"
        loading={priority ? "eager" : "lazy"}
        decoding="async"
        style={{
          objectPosition: `${position(image.focalX)}% ${position(image.focalY)}%`,
        }}
        onError={() => setFailedUrl(src)}
      />
    </div>
  );
}
